var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    ref: "collapseCoAppsInfo",
    attrs: {
      "collapse-id": "co-applicants-info-card",
      "store-path": "coApplicantsInfo",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function (ref) {
          var collapsed = ref.collapsed
          return [
            _c("span", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("application.coApplicants")) +
                  "\n      "
              ),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !collapsed,
                    expression: "!collapsed",
                  },
                ],
                staticClass: "fa fa-info-circle text-grey ml-1",
                attrs: {
                  "aria-hidden": "true",
                  "data-toggle": "tooltip",
                  "data-placement": "top",
                  title: _vm.$t("client-profile.messages.coappChanges"),
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              }),
            ]),
            _vm._v(" "),
            !collapsed
              ? _c(
                  "div",
                  {
                    staticClass: "coapp-actions d-flex align-items-center",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("inline-prompt", {
                      ref: "prompt",
                      staticClass: "bold text-gray mr-2",
                      attrs: { "action-type": "delete" },
                      on: {
                        accept: _vm.deleteCurrentApplicant,
                        prompt: _vm.setCurrentCoApp,
                      },
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass:
                        "fa fa-plus add-coapp text-primary clickable",
                      attrs: { "aria-hidden": "true" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.addCoApplicant.apply(null, arguments)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "form",
              {
                ref: "form",
                attrs: { id: "co-applicants-form", autocomplete: "off" },
                on: {
                  change: _vm.handleSubmit,
                  keydown: _vm.clearTimer,
                  submit: function ($event) {
                    $event.stopPropagation()
                    return _vm.saveOnType.apply(null, arguments)
                  },
                },
              },
              [
                _vm.loading
                  ? _c("co-applicants-info-loader")
                  : [
                      _c(
                        "carousel",
                        _vm._b(
                          {
                            ref: "carousel",
                            attrs: { "mouse-drag": false, "touch-drag": false },
                          },
                          "carousel",
                          _vm.carouselOptions,
                          false
                        ),
                        _vm._l(_vm.coApplicants, function (coApplicant, idx) {
                          return _c(
                            "slide",
                            { key: idx, ref: "slide-" + idx, refInFor: true },
                            [
                              _c("co-applicant-carousel-item", {
                                ref: "item",
                                refInFor: true,
                                attrs: {
                                  id: _vm.clientProfileId,
                                  "co-applicant": coApplicant,
                                  profile: _vm.profile,
                                  index: idx,
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
              ],
              2
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "modal fade",
              attrs: {
                id: "delete-co-applicant-modal",
                tabindex: "-1",
                role: "dialog",
                "aria-hidden": "true",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }